
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 44 44"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30 12h7.059c.52 0 .941.448.941 1s-.421 1-.941 1H34v18.57c0 1.894-1.654 3.43-3.694 3.43H13.694C11.654 36 10 34.464 10 32.57V14H6.941C6.421 14 6 13.552 6 13s.421-1 .941-1H14V9.74C14 7.656 15.61 6 17.557 6h8.886C28.39 6 30 7.655 30 9.74V12zm-.889 2H12v18.332c0 .921.815 1.668 1.82 1.668h16.36c1.005 0 1.82-.747 1.82-1.668V14h-2.889zM28 12V9.74C28 8.803 27.248 8 26.284 8h-8.568C16.752 8 16 8.802 16 9.74V12h12zm-10 7.833c0-.46.448-.833 1-.833s1 .373 1 .833v8.334c0 .46-.448.833-1 .833s-1-.373-1-.833v-8.334zm6 0c0-.46.448-.833 1-.833s1 .373 1 .833v8.334c0 .46-.448.833-1 .833s-1-.373-1-.833v-8.334z"}})])
          )
        }
      }
    